import { LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";
import { ApiResultState } from "../../../root-store/api-result.state";
import { ServiceEvent } from "../../model/event-log";
import { ActivityLogActions } from "../actions";

/**
 * activity log interface
 */
export interface ActivityLog {
    [index: string]: ServiceEvent[];
}

/**
 * security log interface
 */
export interface SecurityLog {
    [index: string]: any;
}

/**
 * event log state interace
 */
export interface EventLogState {
    activityLog: ApiResultState<ActivityLog>;
}

export const initialEventLogState: EventLogState = {
    activityLog: {
        result: {},
        callState: LoadingState.init,
    },
};

export const eventLogReducer = createReducer(
    initialEventLogState,
    on(
        ActivityLogActions.load,
        (state): EventLogState => ({
            ...state,
            activityLog: {
                ...state.activityLog,
                callState: LoadingState.loading,
                error: null,
            },
        })
    ),
    on(
        ActivityLogActions.loadFailure,
        (state, error): EventLogState => ({
            ...state,
            activityLog: {
                ...state.activityLog,
                callState: LoadingState.error,
                error: error.error,
            },
        })
    ),
    on(ActivityLogActions.loadSuccess, (state, payload): EventLogState => {
        const { key, measurement_properties } = payload;
        const {
            activityLog: { result },
        } = state;

        // saving with key, help to not fetching data everytime action has been called
        const updateResult = { ...result, [key]: measurement_properties || [] };
        return {
            ...state,
            activityLog: {
                callState: LoadingState.loaded,
                result: updateResult,
                error: null,
            },
        };
    }),
    on(ActivityLogActions.clear, state => ({
        ...state,
        activityLog: { ...initialEventLogState.activityLog },
    }))
);
